import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { ElectricityCapacityChecksPage, ElectricityCapacityChecksPageProps } from "./ElectricityCapacityChecksPage";

export const EMPTY_PAGE_CONTENT: ElectricityCapacityChecksPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity/capacity-check";

export const ElectricityCapacityChecksPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<ElectricityCapacityChecksPageProps>("capacity_checks", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <ElectricityCapacityChecksPage {...routeProps} {...content} />;
};
